import script from "./tpr-fullscreen.vue?vue&type=script&setup=true&lang=js"
export * from "./tpr-fullscreen.vue?vue&type=script&setup=true&lang=js"

import "./tpr-fullscreen.vue?vue&type=style&index=0&id=405cbede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405cbede"]])

export default __exports__